import OperatorsRepository from "@/js/common/Domain/Repository/Operators";

var OperatorViewModel = Backbone.Epoxy.Model.extend({
	defaults: {
		operators:[],
		filteredHotelsWithoutOperator:[]
	},
	computeds:{
		checked: {
			deps:['operators'],
			get: function(operators) {
				return ~operators.indexOf(this.parentModel.get('id'));
			},
			set: function(value) {
				this.changeChecked(value);
			}
		},
		enabled: {
			deps:['filteredHotelsWithoutOperator'],
			get: function(filteredHotels) {
				var enabled = false,
					tourProducts;

				for(var i = filteredHotels.length-1;i>=0;i--) {
					tourProducts = filteredHotels[i].get('tourProducts');
					for(var j = tourProducts.length-1;j>=0;j--) {
						enabled = tourProducts.at(j).get('tour').get('operator').id == this.parentModel.get('id');
						if(enabled) {
							break;
						}
					}
					if(enabled) {
						break;
					}
				}

				return enabled;
			}
		}
	},
	changeChecked:function(value) {
		var operatorId = this.parentModel.get('id');
		if(value) {
			this.collectionView.addOperator(operatorId);
		} else {
			this.collectionView.removeOperator(operatorId);
		}
	},
	enabledChanged:function(model, value) {
		if(!value && this.get('checked')) {
			this.set('checked', false);
		}
	},
	initModelEvents:function() {
		var self = this;
		this.set('operators', this.filtersModel.get('operators') || []);
		this.filtersModel.on('change:operators', function(model, operators) {
			self.set('operators', operators || []);
		});

		this.set('filteredHotelsWithoutOperator', this.searchPageModel.get('filteredHotelsWithoutOperator') || []);
		this.searchPageModel.on('change:filteredHotelsWithoutOperator', function(model, filteredHotelsWithoutOperator) {
			self.set('filteredHotelsWithoutOperator', filteredHotelsWithoutOperator || []);
		});

		this.on('change:enabled', $.proxy(this.enabledChanged, this))
	},
	initialize:function(options) {
		this.parentModel = options.parentModel;
		this.filtersModel = options.filtersModel;
		this.searchPageModel = options.searchPageModel;
		this.collectionView = options.collectionView;
		this.initModelEvents();
	}
});

var OperatorView = Backbone.Epoxy.View.extend({
	el:'<li class="operatorListItem"></li>',
	template: _.template('<div class="filtersList__item"><label class="checkbox labelTag">\n\t<input type="checkbox" data-layer-name="туроператор_<%=name%>" data-count="<%= count %>">\n\t<div class="checkboxStyle"><span class="icon icon-i16_check_thin"></span></div>\n\t<%= name %>\n</label><div class="filtersList__item-extra">ТОЛЬКО</div></div>'),
	render:function() {
		this.$el.append(this.template(this.model.toJSON()));
	},
	bindings: {
		":el":'classes:{disabled:not(enabled)}',
		"label":"classes:{checked:checked}",
		"input":"checked:checked"
	},
	initialize:function(options) {
		this.render();
		this.viewModel = new OperatorViewModel({
			parentModel: this.model,
			filtersModel: options.collectionView.model,
			searchPageModel:options.collectionView.searchPageModel,
			collectionView:options.collectionView,
		});
		this.collectionView = options.collectionView;
	}
});

var OperatorsFilterViewModel = Backbone.Model.extend({
	default: {
		operators:[]
	}
});


let OperatorsFilterView = Backbone.Epoxy.View.extend({
	itemView: OperatorView,
	events: {
		'click .allOperators input': 'preventCheckboxUncheck'
	},
	bindings: {
		".filtersListContainer" : "collection:$collection",
		".allOperators label":"classes:{checked:allOperators}",
		".allOperators input":"checked:allOperators"
	},
	computeds:{
		allOperators:{
			deps:['operators'],
			get: function(operators) {
				return operators && !operators.length;
			},
			set:function() {
				this.clearOperators();
			}
		},
	},
	preventCheckboxUncheck:function(event) {
		if(!$(event.target).is(':checked')) {
			event.preventDefault();
		}
	},
	getAvailableOperators() {
		return this.viewModel.get('operators');
	},
	syncHotelsChanged() {
		const syncHotels = this.searchPageModel.get('syncHotels');
		const syncTourProducts = _.chain(syncHotels?.models || []).map((syncHotel) => syncHotel.get('tourProducts').models).flatten();

		const operators = syncTourProducts
			.groupBy((tourProduct) => tourProduct.get('tour').get('operator').id)
			.values()
			.map((tourProductGroup) => ({
				...tourProductGroup[0].get('tour').get('operator'),
				count: tourProductGroup.length,
			}))
			.sortBy((operator) => -operator.count)
			.value();

		this.viewModel.set('operators', operators);
		this.collection.reset(operators);
	},
	addOperator:function(operatorId) {
		var operators = this.model.get('operators').slice(0);
		operators.push(operatorId);
		this.model.set('operators', operators);
	},
	removeOperator:function(operatorId) {
		var operators = this.model.get('operators').slice(0);
		this.model.set('operators', _.without(operators, operatorId));
	},
	clearOperators:function() {
		this.model.set('operators', []);
	},
	initModelEvents: function() {
		this.searchPageModel.on('change:syncHotels', this.syncHotelsChanged.bind(this));
	},
	initialize:function(options) {
		this.viewModel = new OperatorsFilterViewModel();
		this.searchPageModel = options.searchPageModel;
		this.collection = new OperatorsRepository();
		this.initModelEvents();
	}
});

export default OperatorsFilterView;